import { Status } from "@shared/enums";
import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultCoaching = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as CoachingEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<CoachingEditCriteria>,
}

export interface CoachingEditCriteria {
  coaching_Id: number;
  driver_Id: number;

  driverApexId: string; // mentee apexId required
  driverName: string; // mentee required

  coachingtime: string; // required
  abstract: string; // required
  coachingResult: string;
  mentorId: string; // required
  mentorName: string; // required
  attachment: string; // required
  attachmentVisibletoDriver: boolean;
  emIncidentNumber: string; // 7 bit
  driver3pl: string;

  status: Status; // only for edit

  driver3PLterminal_Id: number;
  driver3PLflag: boolean;
}
